import { DateTime } from "luxon";

/**
 * Payload REST `where` params for currently visible scheduled content.
 * Matches `shouldPublish()` in publishUtils.js:
 * - publishAt is set and has passed
 * - unpublishAt is empty or still in the future
 *
 * @returns {Record<string, string>}
 */
export function getPublishedScheduleWhereParams() {
  const now = DateTime.now().setZone("America/New_York").toUTC().toISO();

  return {
    "where[publishAt][exists]": "true",
    "where[publishAt][less_than_equal]": now,
    "where[or][0][unpublishAt][exists]": "false",
    "where[or][1][unpublishAt][greater_than]": now,
  };
}
